import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getJobDetails, editJob, getJobCategories } from "../../slice/workerJobSlice";
import QuillEditor from "../text_editor";
import { toast } from "react-toastify"

// const jobCategories = [
//   { id: 1, label: "Accounting/Finance" },
//   { id: 56, label: "|-- Cast Accounting" },
//   { id: 234, label: "|-- |-- Small Business" },
//   { id: 235, label: "|-- |-- E-Commerce Sites" },
//   { id: 236, label: "|-- |-- Portals" },
//   { id: 237, label: "|-- |-- Search Engines" },
//   { id: 238, label: "|-- |-- Personal,Commercial,Govt" },
//   { id: 57, label: "|-- Controllership &amp; Accounting Managment" },
//   { id: 58, label: "|-- Payroll" },
//   { id: 59, label: "|-- Corporate Finance" },
//   { id: 2, label: "Administrative" },
//   { id: 60, label: "|-- Administrative Division" },
//   { id: 61, label: "|-- Autonomous Territories" },
//   { id: 62, label: "|-- Administrative County" },
//   { id: 63, label: "|-- Administrative Communes" },
//   { id: 3, label: "Advertising" },
//   { id: 64, label: "|-- Finance Advertising" },
//   { id: 65, label: "|-- Advertising-Tourism" },
//   { id: 66, label: "|-- Advertising Social Net" },
//   { id: 67, label: "|-- Distributor Marketing" },
//   { id: 68, label: "|-- Facebook Advertising" },
//   { id: 4, label: "Airlines/Avionics/Aerospace" },
//   { id: 69, label: "|-- Quality Engineer" },
//   { id: 70, label: "|-- Office Assistant" },
//   { id: 71, label: "|-- Air Host/hostess" },
//   { id: 72, label: "|-- Ticketing/reservation" },
//   { id: 5, label: "Architectural" },
//   { id: 73, label: "|-- Architectural Drafting" },
//   { id: 74, label: "|-- Enterprize Architecture" },
//   { id: 75, label: "|-- Architecture Frameworks" },
//   { id: 6, label: "Automotive" },
//   { id: 76, label: "|-- Automotive Design" },
//   { id: 77, label: "|-- Autmotive Paints" },
//   { id: 78, label: "|-- Automotive Equipment/Parts" },
//   { id: 79, label: "|-- Automotive Search Engine" },
//   { id: 7, label: "Banking/Finance" },
//   { id: 80, label: "|-- Private Banking" },
//   { id: 81, label: "|-- Stock Brocker" },
//   { id: 82, label: "|-- Fractional-reserve Banking" },
//   { id: 83, label: "|-- Mobile Banking" },
//   { id: 8, label: "Biotechnology" },
//   { id: 84, label: "|-- Plant Biotechnology" },
//   { id: 85, label: "|-- Animal Biotechnology" },
//   { id: 86, label: "|-- Biotechnology &amp; Medicine" },
//   { id: 87, label: "|-- Biotechnology &amp; Society" },
//   { id: 88, label: "|-- Industrail &amp; Microbial Biotechnonogy" },
//   { id: 9, label: "Civil/Construction" },
//   { id: 89, label: "|-- Construction (Design &amp; Managment)" },
//   { id: 90, label: "|-- Construction Engineering" },
//   { id: 91, label: "|-- Composite Construction" },
//   { id: 10, label: "Engineering" },
//   { id: 92, label: "|-- Civil Engineering" },
//   { id: 93, label: "|-- Software Engineering" },
//   { id: 94, label: "|-- Nuclear Engineering" },
//   { id: 95, label: "|-- Ocean Engingeering" },
//   { id: 96, label: "|-- Transpotation Engineering" },
//   { id: 11, label: "Cleared Jobs" },
//   { id: 97, label: "|-- Security Cleared Jobs" },
//   { id: 98, label: "|-- Security Cleared IT Jobs" },
//   { id: 99, label: "|-- Confidential &amp; Secret Security Clearance Job" },
//   { id: 12, label: "Communications" },
//   { id: 100, label: "|-- Verbal" },
//   { id: 101, label: "|-- E-mail" },
//   { id: 102, label: "|-- Non-verbal" },
//   { id: 13, label: "Computer/IT" },
//   { id: 103, label: "|-- Computer Consulting Services" },
//   { id: 104, label: "|-- Computer Installations Services" },
//   { id: 105, label: "|-- Software Vendors" },
//   { id: 14, label: "Construction" },
//   { id: 106, label: "|-- Renovaiton" },
//   { id: 107, label: "|-- Addition" },
//   { id: 108, label: "|-- New Construction" },
//   { id: 15, label: "Consultant/Contractual" },
//   { id: 109, label: "|-- Organization Development" },
//   { id: 110, label: "|-- Construction Management" },
//   { id: 111, label: "|-- Managment Consulting" },
//   { id: 16, label: "Customer Service" },
//   { id: 112, label: "|-- High Touch Customer Service" },
//   { id: 113, label: "|-- Low Touch Customer Service" },
//   { id: 114, label: "|-- Bad Touch Customer Service" },
//   { id: 17, label: "Defense" },
//   { id: 115, label: "|-- By Using legal services for the poor" },
//   { id: 116, label: "|-- By Using Retained Counsel" },
//   { id: 117, label: "|-- By Self-representation" },
//   { id: 18, label: "Design" },
//   { id: 118, label: "|-- Project Subtype Design" },
//   { id: 119, label: "|-- Graphic Design" },
//   { id: 120, label: "|-- Interior Desing" },
//   { id: 19, label: "Education" },
//   { id: 121, label: "|-- IT or Engineering Education" },
//   { id: 122, label: "|-- Commerce &amp; Managment" },
//   { id: 123, label: "|-- Medical Education" },
//   { id: 20, label: "Electrical Engineering" },
//   { id: 124, label: "|-- Power Engineering" },
//   { id: 125, label: "|-- Instrumentation" },
//   { id: 126, label: "|-- Telecommunication" },
//   { id: 127, label: "|-- Signal Processing" },
//   { id: 21, label: "Electronics Engineering" },
//   { id: 128, label: "|-- Electromagnetics" },
//   { id: 129, label: "|-- Network Analysis" },
//   { id: 130, label: "|-- Control Systems" },
//   { id: 22, label: "Energy" },
//   { id: 131, label: "|-- Thermal Energy" },
//   { id: 132, label: "|-- Chemical Energy" },
//   { id: 133, label: "|-- Electrical Energy" },
//   { id: 134, label: "|-- Nuclear Energy" },
//   { id: 23, label: "Environmental/Safety" },
//   { id: 135, label: "|-- Software Engineering" },
//   { id: 136, label: "|-- Civil Engineering" },
//   { id: 137, label: "|-- Nuclear Engineering" },
//   { id: 24, label: "Fundraising" },
//   { id: 138, label: "|-- Nuclear Safety" },
//   { id: 139, label: "|-- Agriculture Safety" },
//   { id: 140, label: "|-- Occupational Health Safety" },
//   { id: 25, label: "Health/Medicine" },
//   { id: 141, label: "|-- Unique Fundraisers" },
//   { id: 142, label: "|-- Sports Fundraiserse" },
//   { id: 143, label: "|-- Fundraisers" },
//   { id: 26, label: "Homeland Security" },
//   { id: 144, label: "|-- Staying Informed" },
//   { id: 145, label: "|-- Medical Edcuation" },
//   { id: 146, label: "|-- Managing a partucular disease" },
//   { id: 27, label: "Human Resources" },
//   { id: 147, label: "|-- Customs &amp; Border Protection" },
//   { id: 148, label: "|-- Federal Law &amp; Enforcement" },
//   { id: 149, label: "|-- Nation Protection" },
//   { id: 28, label: "Insurance" },
//   { id: 150, label: "|-- Benefits Administrators" },
//   { id: 151, label: "|-- Executive Compensation Analysts" },
//   { id: 152, label: "|-- Managment Analysts" },
//   { id: 29, label: "Intelligence Jobs" },
//   { id: 153, label: "|-- Health Insurance" },
//   { id: 154, label: "|-- Life Insurance" },
//   { id: 155, label: "|-- Vehicle Insurance" },
//   { id: 30, label: "Internships/Trainees" },
//   { id: 156, label: "|-- Artificial Intelligence" },
//   { id: 157, label: "|-- Predictive Analytics" },
//   { id: 158, label: "|-- Science &amp; Technology" },
//   { id: 31, label: "Legal" },
//   { id: 159, label: "|-- Work Experience internship" },
//   { id: 160, label: "|-- Research internship" },
//   { id: 161, label: "|-- Sales &amp; Marketing Intern" },
//   { id: 32, label: "Logistics/Transportation" },
//   { id: 162, label: "|-- According To Law" },
//   { id: 163, label: "|-- Defined Rule" },
//   { id: 33, label: "Maintenance" },
//   { id: 164, label: "|-- Shipping" },
//   { id: 165, label: "|-- Transpotation Managment" },
//   { id: 166, label: "|-- Third-party Logistics Provider" },
//   { id: 34, label: "Managemente" },
//   { id: 167, label: "|-- General Maintenance" },
//   { id: 168, label: "|-- Automobile Maintenance" },
//   { id: 169, label: "|-- Equipment Manitenance" },
//   { id: 35, label: "Manufacturing/Warehouse" },
//   { id: 170, label: "|-- Project Managment" },
//   { id: 171, label: "|-- Planning" },
//   { id: 172, label: "|-- Risk Managment" },
//   { id: 36, label: "Marketing" },
//   { id: 173, label: "|-- Quality Assurance" },
//   { id: 174, label: "|-- Product Manager" },
//   { id: 175, label: "|-- Planning Supervisor" },
//   { id: 37, label: "Materials Management" },
//   { id: 176, label: "|-- Networking" },
//   { id: 177, label: "|-- Direct Mail Marketing" },
//   { id: 178, label: "|-- Media Advertising" },
//   { id: 38, label: "Mechanical Engineering" },
//   { id: 179, label: "|-- Supply Chain" },
//   { id: 180, label: "|-- Hazardous Materials Management" },
//   { id: 181, label: "|-- Materials Inventory Managment" },
//   { id: 39, label: "Mortgage/Real Estate" },
//   { id: 182, label: "|-- Aerospace" },
//   { id: 183, label: "|-- Automotive" },
//   { id: 184, label: "|-- Biomedical" },
//   { id: 185, label: "|-- Mechanical" },
//   { id: 186, label: "|-- Naval" },
//   { id: 40, label: "National Security" },
//   { id: 187, label: "|-- Conventional Mortgage" },
//   { id: 188, label: "|-- Adjustable Rate Mortgage" },
//   { id: 189, label: "|-- Commercial Mortgages" },
//   { id: 41, label: "Part-time/Freelance" },
//   { id: 190, label: "|-- Economic Security" },
//   { id: 191, label: "|-- Environmental Security" },
//   { id: 192, label: "|-- Military Security" },
//   { id: 42, label: "Printing" },
//   { id: 193, label: "|-- Freelance Portfolios" },
//   { id: 194, label: "|-- Freelance Freedom" },
//   { id: 195, label: "|-- Freelance Jobs" },
//   { id: 43, label: "Product Design" },
//   { id: 196, label: "|-- Offset Lithographp" },
//   { id: 197, label: "|-- Themography Raised Printing" },
//   { id: 198, label: "|-- Digital Printing" },
//   { id: 44, label: "Public Relations" },
//   { id: 199, label: "|-- idea Generation" },
//   { id: 200, label: "|-- Need Based Generation" },
//   { id: 201, label: "|-- Design Solution" },
//   { id: 45, label: "Public Safety" },
//   { id: 202, label: "|-- Media Relations" },
//   { id: 203, label: "|-- Media Tours" },
//   { id: 204, label: "|-- Newsletters" },
//   { id: 46, label: "Research" },
//   { id: 205, label: "|-- Automised Security" },
//   { id: 206, label: "|-- Environmental &amp; Social Safety" },
//   { id: 47, label: "Retail" },
//   { id: 207, label: "|-- Basic Researc" },
//   { id: 208, label: "|-- Applied Research" },
//   { id: 209, label: "|-- Methods &amp; Appraches" },
//   { id: 48, label: "Sales" },
//   { id: 210, label: "|-- Department Stores" },
//   { id: 211, label: "|-- Discount Stores" },
//   { id: 212, label: "|-- Supermarkets" },
//   { id: 49, label: "Scientific" },
//   { id: 213, label: "|-- Sales Contracts" },
//   { id: 214, label: "|-- Sales Forecasts" },
//   { id: 215, label: "|-- Sales Managment" },
//   { id: 50, label: "Shipping/Distributio" },
//   { id: 216, label: "|-- Scientific Managment" },
//   { id: 217, label: "|-- Scientific Research" },
//   { id: 218, label: "|-- Scientific invenctions" },
//   { id: 51, label: "Technicians" },
//   { id: 219, label: "|-- Shppping/Distrubution Companies" },
//   { id: 220, label: "|-- Services" },
//   { id: 221, label: "|-- Channels &amp; Softwares" },
//   { id: 52, label: "Trades" },
//   { id: 222, label: "|-- Medical Technicians" },
//   { id: 223, label: "|-- Electrical Technicians" },
//   { id: 224, label: "|-- Accounting Technicians" },
//   { id: 53, label: "Transportation" },
//   { id: 225, label: "|-- Construction Trade" },
//   { id: 226, label: "|-- Stock Trade" },
//   { id: 227, label: "|-- skilled Trade" },
//   { id: 228, label: "|-- Option Trade" },
//   { id: 54, label: "Transportation Engineering" },
//   { id: 229, label: "|-- Transpotation System" },
//   { id: 230, label: "|-- Human-Powered" },
//   { id: 231, label: "|-- Airline,Train,bus,car" },
//   { id: 55, label: "Web Site Development" },
//   { id: 232, label: "|-- Subway &amp; Civil" },
//   { id: 233, label: "|-- Traffic Highway Transpotation" },
// ];

const stats = [
  { id: 1, code: 'AL', name: 'Alabama' },
  { id: 2, code: 'AK', name: 'Alaska' },
  { id: 3, code: 'AZ', name: 'Arizona' },
  { id: 4, code: 'AR', name: 'Arkansas' },
  { id: 5, code: 'CA', name: 'California' },
  { id: 6, code: 'CO', name: 'Colorado' },
  { id: 7, code: 'CT', name: 'Connecticut' },
  { id: 8, code: 'DE', name: 'Delaware' },
  { id: 9, code: 'FL', name: 'Florida' },
  { id: 10, code: 'GA', name: 'Georgia' },
  { id: 11, code: 'HI', name: 'Hawaii' },
  { id: 12, code: 'ID', name: 'Idaho' },
  { id: 13, code: 'IL', name: 'Illinois' },
  { id: 14, code: 'IN', name: 'Indiana' },
  { id: 15, code: 'IA', name: 'Iowa' },
  { id: 16, code: 'KS', name: 'Kansas' },
  { id: 17, code: 'KY', name: 'Kentucky' },
  { id: 18, code: 'LA', name: 'Louisiana' },
  { id: 19, code: 'ME', name: 'Maine' },
  { id: 20, code: 'MD', name: 'Maryland' },
  { id: 21, code: 'MA', name: 'Massachusetts' },
  { id: 22, code: 'MI', name: 'Michigan' },
  { id: 23, code: 'MN', name: 'Minnesota' },
  { id: 24, code: 'MS', name: 'Mississippi' },
  { id: 25, code: 'MO', name: 'Missouri' },
  { id: 26, code: 'MT', name: 'Montana' },
  { id: 27, code: 'NE', name: 'Nebraska' },
  { id: 28, code: 'NV', name: 'Nevada' },
  { id: 29, code: 'NH', name: 'New Hampshire' },
  { id: 30, code: 'NJ', name: 'New Jersey' },
  { id: 31, code: 'NM', name: 'New Mexico' },
  { id: 32, code: 'NY', name: 'New York' },
  { id: 33, code: 'NC', name: 'North Carolina' },
  { id: 34, code: 'ND', name: 'North Dakota' },
  { id: 35, code: 'OH', name: 'Ohio' },
  { id: 36, code: 'OK', name: 'Oklahoma' },
  { id: 37, code: 'OR', name: 'Oregon' },
  { id: 38, code: 'PA', name: 'Pennsylvania' },
  { id: 39, code: 'RI', name: 'Rhode Island' },
  { id: 40, code: 'SC', name: 'South Carolina' },
  { id: 41, code: 'SD', name: 'South Dakota' },
  { id: 42, code: 'TN', name: 'Tennessee' },
  { id: 43, code: 'TX', name: 'Texas' },
  { id: 44, code: 'UT', name: 'Utah' },
  { id: 45, code: 'VT', name: 'Vermont' },
  { id: 46, code: 'VA', name: 'Virginia' },
  { id: 47, code: 'WA', name: 'Washington' },
  { id: 48, code: 'WV', name: 'West Virginia' },
  { id: 49, code: 'WI', name: 'Wisconsin' },
  { id: 50, code: 'WY', name: 'Wyoming' },
];

const WorkerEditJob = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const { jobDetails, loading, error, jobCategories } = useSelector(
    (state) => state.workerJob
  );

  const [form, setForm] = useState({
    title: "",
    role_id: "0",
    categories: "",
    job_type: "",
    status: "published",
    salary_min: "",
    salary_max: "",
    salary_type: "",
    duration: "",
    experience_level: "",
    career_level: "",
    no_of_jobs: "",
    city: "",
    state: "",
    description: "",
    country: "US",
    currency: "",
    remote: "0",
    expires_at: "",
  });

  // 1️⃣ Fetch job details
  useEffect(() => {
    dispatch(getJobDetails({ id, token }));
    dispatch(getJobCategories());
  }, [id, token, dispatch]);

  // 2️⃣ Prefill form when data arrives
  useEffect(() => {
    if (jobDetails) {
      setForm({
        title: jobDetails.title || "",
        role_id: jobDetails?.role_id ? String(jobDetails.role_id) : "",
        // categories: jobDetails.jobs_categories?.[0]?.id
        //   ? String(jobDetails.jobs_categories[0].id)
        //   : "",
        categories: jobDetails.categories ? jobDetails.categories : "",
        job_type: jobDetails.job_type || "",
        status: jobDetails.status || "",
        salary_min: jobDetails.salary_min || "",
        salary_max: jobDetails.salary_max || "",
        salary_type: jobDetails.salary_type || "",
        duration: jobDetails.duration || "",
        experience_level: jobDetails.experience_level || "",
        career_level: jobDetails.career_level || "",
        no_of_jobs: jobDetails.no_of_jobs || "",
        expires_at: jobDetails.expires_at
          ? jobDetails.expires_at.split(" ")[0]
          : "",
        city: jobDetails.city || "",
        state: jobDetails.state || "",
        description: jobDetails.description || "",
        country: jobDetails.country || "US",
        currency: jobDetails.currency || "",
        remote: jobDetails.remote ?? "0",
      });
    }
    dispatch(getJobCategories(jobDetails.role_id));
  }, [jobDetails]);

  // 3️⃣ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange1 = (e) => {
    const role = e.target.value;
    const value = e.target.dataset.value;

    dispatch(getJobCategories(role));

    setForm({
      ...form,
      role_id: role,
      title: "Job For " + value, // 👈 set radio value into text input
    });
  };

  const checkValidation = () => {
    if (!form.title) return toast.error("Please enter title"), false;
    if (!form.salary_min) return toast.error("Please enter minimum salay"), false;
    if (!form.salary_max) return toast.error("Please enter maximum salay"), false;
    if (!form.duration) return toast.error("Please enter duration"), false;
    if (!form.experience_level) return toast.error("Please enter experience level"), false;
    if (!form.no_of_jobs) return toast.error("Please enter no of jobs"), false;
    if (!form.expires_at) return toast.error("Please select stop published date"), false;
    if (!form.city) return toast.error("Please enter city"), false;
    if (!form.state) return toast.error("Please enter state"), false;
    if (!form.description) return toast.error("Please enter description"), false;
    return true;
  };


  // 4️⃣ Submit edited job
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!checkValidation()) return;


    const formData = new FormData();

    // 👇 IMPORTANT: pass job_id ONLY for edit
    formData.append("job_id", id);

    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value);
    });

    dispatch(editJob({ token, formData }))
      .unwrap()
      .then(() => {
        toast.success("Job Update Successfully!");
        navigate("/panel/my-job");
      })
      .catch(() => {
        toast.error("Failed to update job");
      });
  };

  // if (loading && !jobDetails) return <p>Loading...</p>;
  // if (error) return <p>Error loading job</p>;

  // console.log("form.role_id", form.role_id);

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <h4 className="font-weight-bold text-primary font-size-40 mb-4 border-bottom pb-3">
          Edit Job
        </h4>

        {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>}

        {/* ERROR */}
        {error && <p className="text-danger">{error}</p>}
        {!loading && !error && (
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-sm-12 d-flex font-size-16">
                <label className="form-label text-primary mb-1 font-weight-semibold">I would like to create job for : </label>
                <div className="d-flex ms-2">
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="role_id"
                      id="fullTime"
                      value="5"
                      data-value="Teachers & Assistants"
                      onChange={handleChange1}
                      checked={form.role_id === "5"}
                    />
                    <label className="form-check-label" htmlFor="fullTime">
                      Teachers & Assistants
                    </label>
                  </div>
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="role_id"
                      id="partTime"
                      value="6"
                      data-value="Support Staffing Roles"
                      onChange={handleChange1}
                      checked={form.role_id === "6"}

                    />
                    <label className="form-check-label" htmlFor="partTime">
                      Support Staffing Roles
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <label className="form-label text-primary mb-1 font-weight-semibold required">Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={form.title}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="col-sm-6">
              <label className="form-label text-primary mb-1 font-weight-semibold required">Category</label>
              <select className="form-select" name="categories" onChange={handleChange} value={form.categories}>
                {jobCategories?.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div> */}
              {form.role_id === "5" && (
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Select Category</label>
                  <select class="form-select form-control" name="categories" value={form.categories} onChange={handleChange}>
                    <option value="">-- Select --</option>
                    {/* <option selected={form.categories === 'Lead Teacher - Infant'} value="Lead Teacher - Infant">Lead Teacher - Infant</option>
                        <option selected={form.categories === 'Lead Teacher - Toddler'} value="Lead Teacher - Toddler">Lead Teacher - Toddler</option>
                        <option selected={form.categories === 'Lead Teacher - 2-Year-Olds'} value="Lead Teacher - 2-Year-Olds">Lead Teacher - 2-Year-Olds</option>
                        <option selected={form.categories === 'Lead Teacher - Preschool (3-5 yrs)'} value="Lead Teacher - Preschool (3-5 yrs)">Lead Teacher - Preschool (3-5 yrs)</option>
                        <option selected={form.categories === 'Assistant Teacher - Infant'} value="Assistant Teacher - Infant">Assistant Teacher - Infant</option>
                        <option selected={form.categories === 'Assistant Teacher - Toddler'} value="Assistant Teacher - Toddler">Assistant Teacher - Toddler</option>
                        <option selected={form.categories === 'Assistant Teacher - 2-Year-Olds'} value="Assistant Teacher - 2-Year-Olds">Assistant Teacher - 2-Year-Olds</option>
                        <option selected={form.categories === 'Assistant Teacher - Preschool (3-5 yrs)'} value="Assistant Teacher - Preschool (3-5 yrs)">Assistant Teacher - Preschool (3-5 yrs)</option> */}
                    {jobCategories?.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {form.role_id === "6" && (
                <div className="col-sm-6">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Select Category</label>
                  <select class="form-select form-control" name="categories" value={form.categories} onChange={handleChange}>
                    <option value="">-- Select --</option>
                    {/* <option selected={form.categories === 'Clerical / Office Support'} value="Clerical / Office Support">Clerical / Office Support</option>
                        <option selected={form.categories === 'Cooks / Kitchen Staff'} value="Cooks / Kitchen Staff">Cooks / Kitchen Staff</option>
                        <option selected={form.categories === 'Janitorial Staff'} value="Janitorial Staff">Janitorial Staff</option>
                        <option selected={form.categories === 'Maintenance Staff'} value="Maintenance Staff">Maintenance Staff</option>
                        <option selected={form.categories === 'Custodians'} value="Custodians">Custodians</option>
                        <option selected={form.categories === 'Floaters / General Support Assistants'} value="Floaters / General Support Assistants">Floaters / General Support Assistants</option>
                        <option selected={form.categories === 'Afternoon Coverage Staff'} value="Afternoon Coverage Staff">Afternoon Coverage Staff</option>
                        <option selected={form.categories === 'Bus / Van Support (Future)'} value="Bus / Van Support (Future)">Bus / Van Support (Future)</option> */}
                    {jobCategories?.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>)
              }
              <div className="col-sm-6">
                <label className="form-label text-primary mb-1 font-weight-semibold required">
                  Type Of Job
                </label>

                <div className="d-flex mt-2">
                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="job_type"
                      id="fullTime"
                      value="full-time"
                      checked={form.job_type === "full-time"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="fullTime">
                      Full-Time
                    </label>
                  </div>

                  <div className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="job_type"
                      id="partTime"
                      value="part-time"
                      checked={form.job_type === "part-time"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="partTime">
                      Part-Time
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="job_type"
                      id="internship"
                      value="internship"
                      checked={form.job_type === "internship"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="internship">
                      Internship
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-sm-3">
                <label className="form-label text-primary mb-1 font-weight-semibold required">With Experience Of</label>
                <div className="input-group">
                  <input
                    type="number"
                    name="experience_level"
                    className="form-control"
                    min="0"
                    step="1"
                    onChange={handleChange}
                    value={form.experience_level}
                    placeholder="Enter experience"
                  />
                  <span className="input-group-text">years</span>
                </div>
              </div>

              {/* <div className="col-sm-6">
              <label className="form-label text-primary mb-1 font-weight-semibold required">Status</label>
              <select className="form-select" name="status" onChange={handleChange} value={form.status}>
                <option value="1">Sourcing</option>
                <option value="2">Interviewing</option>
                <option value="3">Closed to New Applicants</option>
                <option value="4">Finalists Identified</option>
                <option value="5">Pending Approval</option>
                <option value="6">Hold</option>
              </select>
            </div> */}
              <label className="form-label text-primary mb-1 font-weight-semibold">
                Please provide job location
              </label>
              <div className="col-sm-6 d-flex gap-3">
                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">
                    City
                  </label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    value={form.city}
                    onChange={handleChange}
                  />
                </div>

                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">
                    State
                  </label>
                  <select class="form-select" name="state" required="" onChange={handleChange}>
                    <option>Select state</option>
                    {stats.map(cat => (
                      <option selected={form.state === cat.code} key={cat.id} value={cat.code}>{cat.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm-6 d-flex gap-3"></div>

              <div className="col-sm-6 d-flex gap-3">
                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Salary Range Will Be</label>
                  <input
                    type="text"
                    name="salary_min"
                    className="form-control"
                    placeholder="e.g 45000"
                    value={form.salary_min}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold">&nbsp;</label>
                  <input
                    type="text"
                    name="salary_max"
                    className="form-control"
                    placeholder="e.g 45000"
                    value={form.salary_max}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-sm-6 d-flex gap-3">
                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Currency</label>
                  <select className="form-select" name="currency" onChange={handleChange} value={form.currency}>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                  </select>
                </div>

                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">Salary Type</label>
                  <select className="form-select" name="salary_type" onChange={handleChange} value={form.salary_type}>
                    <option value="yearly">Per Year</option>
                    <option value="monthly">Per Month</option>
                    <option value="weekly">Per Week</option>
                  </select>
                </div>
              </div>

              <div className="col-sm-6">
                <label className="form-label text-primary mb-1 font-weight-semibold required">Duration</label>
                <div className="input-group" style={{ maxWidth: "50%" }}>
                  <input
                    type="number"
                    name="duration"
                    className="form-control"
                    min="1"
                    value={form.duration}
                    onChange={handleChange}
                    placeholder="Enter duration"
                  />
                  <span className="input-group-text">
                    {form.salary_type === "yearly"
                      ? "years"
                      : form.salary_type === "monthly"
                        ? "months"
                        : form.salary_type === "weekly"
                          ? "weeks"
                          : ""}
                  </span>
                </div>

              </div>

              <div className="col-sm-6 d-flex gap-3">
                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">
                    Job Openings for
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      name="no_of_jobs"
                      className="form-control"
                      value={form.no_of_jobs}
                      onChange={handleChange}
                      placeholder="Enter Jobs"
                      min="1"
                    />
                    <span className="input-group-text">Jobs</span>
                  </div>
                </div>

                <div className="col">
                  <label className="form-label text-primary mb-1 font-weight-semibold required">
                    Job will be Published Untill:
                  </label>
                  <input
                    type="date"
                    name="expires_at"
                    className="form-control"
                    value={form.expires_at}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* <div className="col-sm-6">
              <label className="form-label text-primary mb-1 font-weight-semibold required">Career Level</label>
              <select className="form-select" name="career_level" onChange={handleChange} value={form.career_level}>
                <option value="1">Student (Undergraduate)</option>
                <option value="2">Student (Graduate)</option>
                <option value="3">Entry Level</option>
                <option value="4">Experienced (Non-Manager)</option>
                <option value="5">Manager</option>
                <option value="6">Executive (Department Head, SVP, VP etc)</option>
                <option value="7">Senior Executive (President, CEO, etc)</option>
              </select>
            </div> */}

              {/* <div className="col-sm-6">
              <label className="form-label text-primary mb-1 font-weight-semibold required">Remote</label>
              <select className="form-select" name="remote" onChange={handleChange} value={form.remote}>
                <option value="0">False</option>
                <option value="1">True</option>
              </select>
            </div> */}

              <div >
                <label className="form-label text-primary mb-1 font-weight-semibold required">Provide some Details of Job</label>
                <QuillEditor
                  value={form.description}
                  onChange={(val) => setForm(prev => ({ ...prev, description: val }))}
                />
              </div>
              <div className="col-12 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Job"}
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default WorkerEditJob;
